import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Content = styled.form`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: ${theme.spacing.xs};
  margin-top: ${theme.spacing.xm};

  & label {
    margin-left: 0;
  }
`

export const WrapButtons = styled.div`
  margin-top: ${theme.spacing.xm};
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${theme.spacing.sm};
`

export const WrapChoosePeriod = styled.div`
  background-color: ${theme.colors.neutral[100]};
  border: 1px solid ${theme.colors.neutral.clear};
  border-radius: ${theme.shapes.borderRadius.md};
  width: 100%;
  margin-top: ${theme.spacing.sm};
  padding: ${theme.spacing.xm};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};

  & > p {
    margin: 0;
    color: ${theme.colors.neutral.medium};
  }
`

export const WrapMonthInputs = styled.div`
  display: flex;
  gap: ${theme.spacing.md};
`
